import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { FormsModule } from '@angular/forms';

import  InventoryMain  from './inventory-main.component';
import { InventoryService }  from './services/inventory.service';
import { InventoryLanding } from './inventory-landing/inventory-landing.component';
import { InventoryTreeVCD } from './inventory-tree/vcd/inventory-tree-vcd.component';
import { InventoryTreeVC } from './inventory-tree/vc/inventory-tree-vc.component';
import { InventoryTreeHolder } from './inventory-tree/tree-holder/inventory-tree-holder.component';

import { NetworkTreeHolder } from './network-tree/network-tree-holder/network-tree-holder.component';
import { NetworkTreeVCD } from './network-tree/network-tree-vcd/network-tree-vcd.component';

import { VcaCommonModule } from '../../../common';
import { ComputeVCDModule } from '../compute/compute-vcd/compute-vcd.module';

import AddOrganization from '../../components/compute/compute-vcd/organization/add/organization-add.component';

import { InventoryRoutingModule }  from './inventory-routing.module';
import { ResizableModule } from 'angular-resizable-element';
import { RefreshSharedService } from '../../refresh-shared-service'
import { NetworkModule } from '../network/network.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        ClarityModule.forRoot(),
        VcaCommonModule,
        InventoryRoutingModule,
        ResizableModule,
        ComputeVCDModule,
        NetworkModule
    ],
    declarations: [
        InventoryMain,
        InventoryLanding,
        InventoryTreeVC,
        InventoryTreeVCD,
        InventoryTreeHolder,
        NetworkTreeHolder,
        NetworkTreeVCD,
        AddOrganization
    ],
    providers: [
        InventoryService,
        RefreshSharedService
    ],
    exports: [
        InventoryMain,
        InventoryLanding,
        InventoryTreeVC,
        InventoryTreeVCD,
        InventoryTreeHolder,
        NetworkTreeHolder,
        NetworkTreeVCD,
        AddOrganization
    ]
})
export class InventoryModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory.module.ts